import SmoothScroll from "smooth-scroll";

export const hashLink = () => {
  (function(window, document) {
    /**
     * ページ内リンク発生時に、移動先の要素にfocusを移す
     */
    const $hashLinkElms = document.querySelectorAll("[href^=\"#\"]");
    Array.prototype.forEach.call($hashLinkElms, elem => {
      elem.addEventListener("click", e => {
        const targetElement = document.querySelector(e.currentTarget.hash);
        targetElement.focus();
      });
    });
    /**
     * NOTE 本当はscroll-behaviorで対応したいが、
     * 1. リンクが反応しない
     * 2. 中途半端なところでスクロールが止まる
     * ことがあるため、解消させるまで活用
     */
    const globalHeaderHeight = getComputedStyle(document.documentElement).getPropertyValue("--global-header_height");
    // @ts-ignore
    const scroll = new SmoothScroll("[href^=\"#\"]", { // eslint-disable-line @typescript-eslint/no-unused-vars
      speed: 1000,
      speedAsDuration: true,
      offset: function() {
        // #mastheadが存在しない場合はoffset不要の判定オプション
        if (document.body.classList.contains("no-masthead")) {
          return 0;
        }

        if (globalHeaderHeight) {
          return parseInt(globalHeaderHeight);
        }

        return 0;
      }
    });

    // NOTE アンカー制御は現在のCSS APIで対応できるため不要
  })(window, document);
};